import React from "react";
import {translator} from "core/localization/localization";
import PropTypes from "prop-types";
import {AddButton} from "controls/react/windows/addButton";
import {openAuthenticationForm} from "areas/administration/authentication/components/authentication-form/openAuthenticationForm";

const i18n = translator({
  "Create new authentication": {
    "no": "Opprett ny autentisering",
    "en": "Create new authentication"
  }
});

export class AddAuthentication extends React.PureComponent {
	constructor(props) {
		super(props);
	}

	onClick = () => {
		openAuthenticationForm({
			mode: 'create',
			accountId: this.props.accountId,
			authTypes: this.props.authTypes,
			onSaved: this.props.onCreated
		});
	}

	render() {
		return <AddButton className={this.props.containerClass}
		                  label={i18n('Create new authentication')}
		                  onClick={this.onClick}
		                  disabled={this.props.disabled} />
	}
}

AddAuthentication.propTypes = {
	types: PropTypes.array,
	onCreated: PropTypes.func,
	authTypes: PropTypes.array,
	accountId: PropTypes.string,
};

export default AddAuthentication;
